<script>
export default {
    name: "PrintDischargeRequest",

    data() {

        return {
            visit: {},
        };
    },

    mounted() {

        this.fetchVisit().then(() => {
            window.print();
            window.onafterprint = () => window.close();
        });
    },

    methods: {

        fetchVisit() {

            return this.$http.get(`Admissions/GetDischargeSheet?VisitNo=${this.$route.params.visitID}`).then(response => {
                this.visit = response.data[0];
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap text-gray-900">
        <tail-address-header></tail-address-header>
        <div class="w-full my-2 text-center p-1">
            <h5 class="font-bold">PATIENT DISCHARGE REQUEST NOTE</h5>
        </div>
        <div class="w-full flex flex-row px-1 border-t-2 border-gray-400 mt-1">
            
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">Name:{{ visit.names }}</h5>
            </div>
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">MRN:{{ visit.patienT_ID }}</h5>
            </div>
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">Date:{{ visit.requestedOn | dateFormat }}</h5>
            </div>
             
        </div>
        <div class="w-full flex flex-row px-1 border-t-2 border-gray-400 mt-1">
            
             <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">Date:{{ visit.dateadmitted | dateFormat }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Ward:{{ visit.ward }}</h5>
            </div><div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Bed:{{ visit.bed }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Payment Mode:{{ visit.pMode }}</h5>
            </div>
        </div>

         
        <div class="w-full my-1 text-right">
            <h5 class="font-semibold">Initiated By:{{visit.userName}}</h5>
        </div>
    </div>
</template>
